<template>
    <c-dialog ref="dialog" title="统计报告详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <span v-if="saasName" class="m-detail-saas">{{saasName}}</span>
            </div>
        </template>

        <module>
            <module-col size="320">
                <c-detail class="m-detail-form">
                    <c-detail-item label="所属商户">
                        {{saasName || '-'}}
                    </c-detail-item>
                    <c-detail-item label="场次">
                        {{master.auction_batch_no || '-'}}
                    </c-detail-item>
                    <c-detail-item label="总台数">
                        {{master.total_cnt == null ? '-' : master.total_cnt}}
                    </c-detail-item>
                    <c-detail-item label="成交台数">
                        {{master.deal_cnt == null ? '-' : master.deal_cnt}}
                    </c-detail-item>
                    <c-detail-item label="成交总额">
                        {{formatPrice(master.deal_amount)}}
                    </c-detail-item>
                    <c-detail-item label="毛利">
                        {{formatPrice(master.gross_profit)}}
                    </c-detail-item>
                    <c-detail-item label="毛利率">
                        {{formatRate(master.gross_profit_rate)}}
                    </c-detail-item>
                    <c-detail-item label="平均毛利">
                        {{formatPrice(master.avg_gross_profit)}}
                    </c-detail-item>
                    <c-detail-item label="报告生成时间">
                        {{master.report_gen_time || '-'}}
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="渠道汇总" enable-flex>
                    <div class="m-detail-box">
                        <c-table :data="summaryList" border :paging="false">
                            <c-table-column label="销售渠道" min-width="160">
                                <template #default="{data}">{{data.channel_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="成交台数" width="100">
                                <template #default="{data}">{{data.deal_cnt}}</template>
                            </c-table-column>
                            <c-table-column label="成交额" width="120">
                                <template #default="{data}">{{formatPrice(data.deal_amount)}}</template>
                            </c-table-column>
                            <c-table-column label="毛利" width="120">
                                <template #default="{data}">{{formatPrice(data.gross_profit)}}</template>
                            </c-table-column>
                            <c-table-column label="毛利率" width="100">
                                <template #default="{data}">{{formatRate(data.gross_profit_rate)}}</template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>

                <module-tab name="成交明细" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="dealTable">
                            <c-table-column label="产品信息" width="280">
                                <template #default="{data}">{{data.product_info || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="背贴码" width="140">
                                <template #default="{data}">{{data.produce_unique_code || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="IMEI" width="150">
                                <template #default="{data}">{{data.produce_imei || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="成交渠道" width="130">
                                <template #default="{data}">{{data.win_channel_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="成交价" width="100">
                                <template #default="{data}">
                                    <span style="color: #e53e3e;">{{formatPrice(data.deal_price)}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="订单号" width="160">
                                <template #default="{data}">{{data.order_no || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="订单状态" width="90">
                                <template #default="{data}">{{data.order_state_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="成交时间" width="160">
                                <template #default="{data}">{{data.deal_time || '-'}}</template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpAuctionStatReportDetail',

    data() {
        return {
            saasId: '',
            saasName: '',
            reportId: '',
            master: {},
            summaryList: []
        }
    },

    methods: {
        /*********打开抽屉（data=列表行）**********/
        open(data = {}) {
            this.saasId = data.saas_id;
            this.saasName = data.saas_name || '';
            this.reportId = data.id;
            this.master = {};
            this.summaryList = [];
            this.$refs.dialog.open();
            this.loadDetail();
        },

        /*********加载报告详情**********/
        loadDetail() {
            this.request({
                url: '/sale/auction/report/stat/ops/master',
                data: {
                    merchant_id: this.saasId,
                    id: this.reportId
                },
                loading: true,
                success: data => {
                    this.master = data || {};
                    this.summaryList = this.parseSummary(this.master.channel_summary_json);
                    this.$nextTick(() => {
                        this.$refs.dealTable && this.$refs.dealTable.load({
                            url: '/sale/auction/report/stat/ops/detail',
                            data: {
                                merchant_id: this.saasId,
                                id: this.reportId
                            }
                        });
                    });
                }
            });
        },

        /*********解析渠道汇总JSON**********/
        parseSummary(json) {
            try {
                var list = JSON.parse(json || '[]');
                return Array.isArray(list) ? list : [];
            } catch (e) {
                return [];
            }
        },

        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },

        /*********格式化百分比**********/
        formatRate(rate) {
            if (rate === null || rate === undefined || rate === '') return '-';
            return parseFloat(rate).toFixed(2) + '%';
        }
    }
}
</script>

<style scoped>
.m-detail-tag {
    gap: 8px;
    font-size: 14px;
    font-weight: bold;
}

.m-detail-saas {
    font-size: 12px;
    font-weight: normal;
    color: #999;
}

.m-detail-box {
    padding: 10px;
}
</style>
